<template>
  <div class="form-check posttype-toggle">
    <input
      class="form-check-input"
      type="checkbox"
      :value="checkbox.term_id"
      :id="checkbox.name"
      v-model="value"
    />
    <label
      class="form-check-label"
      :for="checkbox.name"
      v-html="checkbox.label"
    ></label>
  </div>
</template>

<script>
export default {
  name: "PosttypeToggle",
  props: ["checkbox"],
  computed: {
    value: {
      get() {
        return this.$store.state.post_types.indexOf(this.checkbox.name) > -1;
      },
      set(val) {
        if (val) {
          this.$store.commit("ADD_POSTTYPE", [
            this.checkbox.label,
            this.checkbox.name,
          ]);
        } else {
          this.$store.commit("REMOVE_POSTTYPE", this.checkbox.name);
        }

        this.$store.dispatch("newRequest");
      },
    },
  },
};
</script>
